import { render, staticRenderFns } from "./baomingliucheng.vue?vue&type=template&id=6b405c33&scoped=true"
import script from "./baomingliucheng.vue?vue&type=script&lang=js"
export * from "./baomingliucheng.vue?vue&type=script&lang=js"
import style0 from "./baomingliucheng.vue?vue&type=style&index=0&id=6b405c33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b405c33",
  null
  
)

export default component.exports